export default __webpack_public_path__ + "static/media/llamado-1-mb@2x.36e7713c.png";